import React, { useEffect } from "react";
import Body from "@appsinti/stats-frontend/home/components/Body";
import { useData } from "../../data";
import IChartData from "../../../interfaces/IChartData";
import LineChart from "../../components/charts/line";
import BarChart from "../../components/charts/bar";

const Cost: React.FC = () => {
  const { costs, fetchCosts } = useData();

  useEffect(() => {
    fetchCosts();
  }, []);

  return (
    <Body>
      {costs?.map((graph: IChartData | null, index: React.Key | null | undefined) => {
        if (!graph) return null;
        if (graph.type === "line") {
          return (
            <LineChart
              key={index}
              dataObject={graph}
            />
          );
        }

        if (graph.type === "bar") {
          return (
            <BarChart
              key={index}
              dataObject={graph}
            />
          );
        }
        return null;
      })}
    </Body>
  );
};
export default Cost;
